module.exports = __webpack_public_path__ + "img/logo-text.a2ef001b.svg";